function encrypt(n) {
    return btoa(n)
  }
  
  export default encrypt